/* eslint-disable */
const localization = {
    // This is the array of lexemes found in the app
    lexemes: [
      "The Friendship Hub",
      "Find New Friends With Bumble For Friends App | Bumble",
      "Download on the App Store",
      "Get it on Google Play",
      "A dedicated space to make new friends",
      "Discover people near you who are here for genuine connections.",
      "Find friends for all stages of life",
      "New to town? Need a fresh start? Your new crew is waiting for you!",
      "A safe space for everyone",
      "Welcome to a kind part of the internet, where you can be you.",
      "Download the app",
      "Meet IRL with people who share your interests!",
      "Get to know a new group of people with Plans on Bumble For Friends",
      "You’ve been invited to join Plans",
      "Plans is a new feature on Bumble For Friends where you can create and join group meetups with new friends near you",
      "Manage Cookies",
      "Gender Pay Gap",
      "Modern Slavery Statement",
      "Terms and Conditions",
      "About",
      "Life"
],

    // These are the common words found in the lexemes of the app
    common: {
      "day": {
            "few": [
                  "dni",
                  "dní",
                  "dňom",
                  "dni",
                  "dňoch",
                  "dňami"
            ],
            "many": [
                  "dní",
                  "dní",
                  "dňom",
                  "dní",
                  "dňoch",
                  "dňami"
            ],
            "plural": [
                  "dní",
                  "dní",
                  "dňom",
                  "dní",
                  "dňoch",
                  "dňami"
            ],
            "singular": [
                  "deň",
                  "dňa",
                  "dňu",
                  "deň",
                  "dni",
                  "dňom"
            ]
      },
      "hour": {
            "few": [
                  "hodiny",
                  "hodín",
                  "hodinám",
                  "hodiny",
                  "hodinách",
                  "hodinami"
            ],
            "many": [
                  "hodín",
                  "hodín",
                  "hodinám",
                  "hodín",
                  "hodinách",
                  "hodinami"
            ],
            "plural": [
                  "hodín",
                  "hodín",
                  "hodinám",
                  "hodín",
                  "hodinách",
                  "hodinami"
            ],
            "singular": [
                  "hodina",
                  "hodiny",
                  "hodine",
                  "hodinu",
                  "hodine",
                  "hodinou"
            ]
      },
      "minute": {
            "few": [
                  "minúty",
                  "minút",
                  "minútam",
                  "minúty",
                  "minútach",
                  "minútami"
            ],
            "many": [
                  "minút",
                  "minút",
                  "minútam",
                  "minút",
                  "minútach",
                  "minútami"
            ],
            "plural": [
                  "minút",
                  "minút",
                  "minútam",
                  "minút",
                  "minútach",
                  "minútami"
            ],
            "singular": [
                  "minúta",
                  "minúty",
                  "minúte",
                  "minútu",
                  "minúte",
                  "minútou"
            ]
      },
      "month": {
            "few": [
                  "mesiace",
                  "mesiacov",
                  "mesiacom",
                  "mesiace",
                  "mesiacoch",
                  "mesiacmi"
            ],
            "many": [
                  "mesiacov",
                  "mesiacov",
                  "mesiacom",
                  "mesiacov",
                  "mesiacoch",
                  "mesiacmi"
            ],
            "plural": [
                  "mesiacov",
                  "mesiacov",
                  "mesiacom",
                  "mesiacov",
                  "mesiacoch",
                  "mesiacmi"
            ],
            "singular": [
                  "mesiac",
                  "mesiaca",
                  "mesiacu",
                  "mesiac",
                  "mesiaci",
                  "mesiacom"
            ]
      },
      "second": {
            "few": [
                  "sekundy",
                  "sekúnd",
                  "sekundám",
                  "sekundy",
                  "sekundách",
                  "sekundami"
            ],
            "many": [
                  "sekúnd",
                  "sekúnd",
                  "sekundám",
                  "sekúnd",
                  "sekundách",
                  "sekundami"
            ],
            "plural": [
                  "sekúnd",
                  "sekúnd",
                  "sekundám",
                  "sekúnd",
                  "sekundách",
                  "sekundami"
            ],
            "singular": [
                  "sekunda",
                  "sekundy",
                  "sekunde",
                  "sekundu",
                  "sekunde",
                  "sekundou"
            ]
      },
      "year": {
            "few": [
                  "roky",
                  "rokov",
                  "rokom",
                  "roky",
                  "rokoch",
                  "rokmi"
            ],
            "many": [
                  "rokov",
                  "rokov",
                  "rokom",
                  "rokov",
                  "rokoch",
                  "rokmi"
            ],
            "plural": [
                  "rokov",
                  "rokov",
                  "rokom",
                  "rokov",
                  "rokoch",
                  "rokmi"
            ],
            "singular": [
                  "rok",
                  "roka",
                  "roku",
                  "rok",
                  "roku",
                  "rokom"
            ]
      }
}
};

// In dev mode we extend lexemes to include the indexMap as well, in production it remains as an array
if (__DEV__) {
    // This is a map of lexeme ids to their index in the array, it's only needed during development
    const indexMap = require('./index-map').default;

    localization.indexMap = indexMap;

    Object.entries(localization.indexMap).forEach(([indexKey, indexValue]) => {
        localization.lexemes[indexKey] = localization.lexemes[indexValue];
    });
}

export default localization;
